// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"841":"ae294cdd","884":"bfaa75e3","991":"d7b6bbe3"}[chunkId] + ".chunk.css";
};